"use strict";
//@ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64ImageToFile = exports.angleToPoint = void 0;
function angleToPoint(angle, sx, sy) {
    while (angle < 0)
        angle += 360;
    angle %= 360;
    var a = sy, b = a + sx, c = b + sy, // 3 first corners
    p = (sx + sy) * 2, // perimeter
    rp = p * 0.00277, // ratio between perimeter & 360
    pp = Math.round((angle * rp + (sy >> 1)) % p); // angle position on perimeter
    if (pp <= a)
        return { x: 0, y: sy - pp };
    if (pp <= b)
        return { y: 0, x: pp - a };
    if (pp <= c)
        return { x: sx, y: pp - b };
    return { y: sy, x: sx - (pp - c) };
}
exports.angleToPoint = angleToPoint;
function base64ImageToFile(str) {
    // extract content type and base64 payload from original string
    var pos = str.indexOf(";base64,");
    var type = str.substring(5, pos);
    var b64 = str.substr(pos + 8);
    // decode base64
    var imageContent = atob(b64);
    // create an ArrayBuffer and a view (as unsigned 8-bit)
    var buffer = new ArrayBuffer(imageContent.length);
    var view = new Uint8Array(buffer);
    // fill the view, using the decoded base64
    for (var n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }
    // const filename = `background.${type.split('/')[1]}`
    // convert ArrayBuffer to Blob
    var blob = new Blob([buffer], { type: type });
    var objectURL = URL.createObjectURL(blob);
    // const file = new File([blob], filename)
    return objectURL;
}
exports.base64ImageToFile = base64ImageToFile;
//# sourceMappingURL=parser.js.map